import { Route, Routes } from 'react-router-dom';

import { useAuthContext } from '../contexts/AuthContext';
import Batches from '../pages/Batches';
import BatchPage from '../pages/BatchPage';

import Agp from '../pages/Agp';
import AgpStorageCheck from '../pages/AgpStorageCheck';
import Audit from '../pages/Audit';
import BrewView from '../pages/Brew';
import Home from '../pages/Home';
import Inventory from '../pages/Inventory';
import InventoryCheck from '../pages/InventoryCheck';
import InventoryItemPage from '../pages/InventoryItemPage';
import InvoicePage from '../pages/InvoicePage';
import Invoices from '../pages/Invoices';
import NotApproved, { Denied } from '../pages/NotApproved';
import Plan from '../pages/Plan';
import RecipePage from '../pages/RecipePage';
import Recipes from '../pages/Recipes';
import SalesInvoicePage from '../pages/SalesInvoicePage';
import SalesInvoices from '../pages/SalesInvoices';
import Settings from '../pages/Settings';
import { ShoppingList } from '../pages/ShoppingList';
import Stocks from '../pages/Stocks';
import Suggestions from '../pages/Suggestions';
import Tools from '../pages/Tools';
import WikiHistory from '../pages/Wiki/Wiki.History';
import WikiEdit from '../pages/Wiki/WikiEdit';
import WikiList from '../pages/Wiki/WikiList';
import WikiNew from '../pages/Wiki/WikiNew';
import WikiView from '../pages/Wiki/WikiView';

export const Routing = () => {
  const { currentUser, userObject } = useAuthContext();

  if (!currentUser) {
    return (
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    );
  }

  if (userObject?.denied) {
    return (
      <Routes>
        <Route path="/" element={<Denied />} />
      </Routes>
    );
  }

  if (!userObject?.approved) {
    return (
      <Routes>
        <Route path="/" element={<NotApproved />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/brew/:brewId?" element={<BrewView />} />
      <Route path="/inventory" element={<Inventory />} />
      <Route path="/inventoryCheck" element={<InventoryCheck />} />
      <Route path="/agp" element={<Agp />} />
      <Route path="/agpStorageCheck" element={<AgpStorageCheck />} />
      <Route path="/inventory/:id" element={<InventoryItemPage />} />
      <Route path="/recipes" element={<Recipes />} />
      <Route path="/recipes/:id" element={<RecipePage />} />
      <Route path="/plan" element={<Plan />} />
      <Route path="/batches" element={<Batches />} />
      <Route path="/batches/:id" element={<BatchPage />} />
      <Route path="/batches/:id/recipe/:recipe" element={<RecipePage />} />
      <Route path="/batches/:id/modal/:modal" element={<BatchPage />} />
      <Route path="/batches/:id/modal/:modal/:s" element={<BatchPage />} />
      <Route path="/shopping-list" element={<ShoppingList />} />
      <Route path="/stock" element={<Stocks />} />
      <Route path="/invoices" element={<Invoices />} />
      <Route path="/invoices/:id" element={<InvoicePage />} />
      <Route path="/audit" element={<Audit />} />
      <Route path="/tools" element={<Tools />} />
      <Route path="/sales" element={<SalesInvoices />} />
      <Route path="/sales/:id" element={<SalesInvoicePage />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/suggestions" element={<Suggestions />} />
      {/* Wiki */}
      <Route path="wiki" element={<WikiList />} />
      <Route path="wiki/new" element={<WikiNew />} />
      <Route path="wiki/:slug" element={<WikiView />} />
      <Route path="wiki/:slug/edit" element={<WikiEdit />} />
      <Route path="wiki/:slug/history" element={<WikiHistory />} />

      <Route path="/" element={<Home />} />
    </Routes>
  );
};
